import React, { Component } from 'react';
import { CatVo } from '../classes/dataObjects/CatVo';
import { TreeLoader } from '../classes/TreeLoader';

import TreeImage from '../comps/TreeImage';
import { SubCatVo } from '../classes/dataObjects/SubCatVo';
import { StatLoader } from '../classes/StatLoader';
import { MainStorage } from '../classes/MainStorage';
import { TopicVo } from '../classes/dataObjects/TopicVo';
interface MyProps { callback: Function }
interface MyState { branches: CatVo[], mode: number,loading:boolean }
class TreeScreen extends Component<MyProps, MyState> {

    private ms: MainStorage = MainStorage.getInstance();
    private langDiff: string[] = "Easy,Medium,Hard,Expert,,Song".split(',');
    private subjectArray: string[] = ['', 'Language', 'Literature', 'History', 'Vocabulary', 'Math', 'Biography', 'Geography', 'Science', 'Art'];
    constructor(props: MyProps) {
        super(props);
       // let mode: number = (this.ms.isLoggedIn) ? 0 : 2;
        this.state = { branches: [], mode: 2,loading:true };
    }
    componentDidMount() {
        this.getStats();
    }
    changeSubject(subjectID: number) {
        this.setState({loading:true});
        this.ms.subjectID = subjectID;
        this.getStats();
    }
    getStats() {
        if (this.ms.userCode === '') {
            this.getTree();
            return;
        }
        const statLoader: StatLoader = new StatLoader(this.getTree.bind(this));
        statLoader.getPlayedGames(this.ms.subjectID);
    }

    getTree() {
        const treeLoader: TreeLoader = new TreeLoader(this.gotTree.bind(this));
        treeLoader.loadTree(this.ms.subjectID);
    }
    gotTree(branch: CatVo[]) {
        // console.log(branch);
        this.setState({ branches: branch ,loading:false});
    }
    getLangTreePage() {
        console.log(this.state.branches);
        //language does not have subcats
        let elements: JSX.Element[] = [];
        for (let i: number = 0; i < this.state.branches.length; i++) {
            let branch: CatVo = this.state.branches[i];
            const key: string = "cat" + branch.id;
            elements.push(<h3 key={key}>{branch.catName}</h3>);
            for (let j: number = 0; j < this.langDiff.length; j++) {
                //skip empty difficulty
                if (this.langDiff[j] === '') continue;
                //add divs for topics
                let topics: JSX.Element | null = this.getLangTopics(branch, j);
                if (topics !== null) {
                    const key2: string = "diff" + j + "-" + branch.id;
                    elements.push(<h4 key={key2}>{this.langDiff[j]}</h4>);
                    elements.push(topics);
                }
            }
        }
        return elements;
    }
    getLangTopics(catVo: CatVo, diff: number = 0) {
        let elements: JSX.Element[] = [];
        let len: number = catVo.topics.length;
        if (len === 0) return null;

        for (let i: number = 0; i < len; i++) {

            let topic: TopicVo = catVo.topics[i];
            if (topic.difficulty !== diff) continue;
            const key: string = "topic" + catVo.topics[i].id + "-" + diff;
            // elements.push(<div key={key}>{subcat.topics[i].topicName}</div>);
            let unlocked: boolean = this.getUnlocked(catVo.topics[i]);
            //  // console.log(subcat.topics[i].id + " unlocked: " + unlocked);
            elements.push(<TreeImage key={key} topicVo={catVo.topics[i]} callback={this.props.callback} useGray={!unlocked} />);
        }
        const subcatKey: string = "topics" + catVo.id + "-" + diff;
        return <div className='topics' key={subcatKey}>{elements}</div>;
    }
    getTreePage() {
        if (this.ms.subjectID === 1) return this.getLangTreePage();
        let elements: JSX.Element[] = [];
        for (let i: number = 0; i < this.state.branches.length; i++) {
            let branch: CatVo = this.state.branches[i];
            const key: string = "cat" + branch.id;
            elements.push(<h3 key={key}>{branch.catName}</h3>);
            //add divs for subcats and topics
            for (let j: number = 0; j < branch.subcats.length; j++) {
                const key2: string = "subcat" + branch.subcats[j].id;
                let subcat: any = branch.subcats[j];
                elements.push(<h4 key={key2}>{subcat.subcatName}</h4>);
                elements.push(this.getTopics(subcat));
            }
        }
        return elements;
    }
    getTopics(subcat: SubCatVo) {
        let elements: JSX.Element[] = [];
        for (let i: number = 0; i < subcat.topics.length; i++) {
            const key: string = "topic" + subcat.topics[i].id;
            // elements.push(<div key={key}>{subcat.topics[i].topicName}</div>);
            let unlocked: boolean = this.getUnlocked(subcat.topics[i]);
            //  // console.log(subcat.topics[i].id + " unlocked: " + unlocked);
            elements.push(<TreeImage key={key} topicVo={subcat.topics[i]} callback={this.props.callback} useGray={!unlocked} />);
        }
        const subcatKey: string = "topics" + subcat.id;
        return <div className='topics' key={subcatKey}>{elements}</div>;
    }
    getUnlocked(topic:TopicVo) {
        const topicID: number = topic.id;
        const level: number = topic.level;
        //mode 0=unlocked, 1=played, 2=unlocked
        switch (this.state.mode) {
            case 0:
                return this.ms.checkUnlocked(topicID);
            case 1:
                return this.ms.checkPlayed(topicID);
            case 2:
                return true;
            case 3:
                return(level===0);
            case 4:
                return(level!==0);
            default:
                return false;
        }
    }
    getHighlightButtons() {
        let buttons: JSX.Element[] = [];
        let buttonNames: string[] = ['Completed', 'Played', 'All'];
        for (let i: number = 0; i < buttonNames.length; i++) {
            let disabled: boolean = (i === this.state.mode);
            buttons.push(<button className='subjectButton' key={i} disabled={disabled} onClick={() => this.setState({ mode: i })}>{buttonNames[i]}</button>);
        }
        return <div className='hbuttons'>{buttons}</div>;
    }
    getHighlightDropdown() {
        let options: JSX.Element[] = [];
        let buttonNames: string[] = ['Completed', 'Played', 'All',"Free","Premium"];
        for (let i: number = 0; i < buttonNames.length; i++) {
            options.push(<option key={i} value={i}>{buttonNames[i]}</option>);
        }
        return <select value={this.state.mode} onChange={(e) => this.setState({ mode: parseInt(e.target.value) })}>{options}</select>;
    }
    
    getSubjectButtons() {
        let buttons: JSX.Element[] = [];
        for (let i: number = 1; i < this.ms.subjects.length; i++) {
            let subject: CatVo = this.ms.subjects[i];
            let disabled: boolean = (subject.id === this.ms.subjectID);
            //use icon on button
            buttons.push(<button className='subjectButton' key={i} disabled={disabled} onClick={() => this.changeSubject(subject.id)}>
                <img src={subject.icon} alt={subject.catName} />
                {subject.catName}</button>);
            //buttons.push(<Button key={i} disabled={disabled} onClick={() => this.changeSubject(i)}>{this.subjectArray[i]}</Button>);
        }
        return <div className='subjectButtons' style={{ "marginBottom": "5vh" }}>{buttons}</div>;
    }
    getSubjectDropdown() {
        let options: JSX.Element[] = [];
        for (let i: number = 0; i < this.ms.subjects.length; i++) {
            let subject: CatVo = this.ms.subjects[i];
            console.log("subject: "+subject.catName);
            options.push(<option key={i} value={subject.id}>{subject.catName}</option>);
        }
        return <select value={this.ms.subjectID} onChange={(e) => this.changeSubject(parseInt(e.target.value))}>{options}</select>;
    }
    render() {
        if (this.state.loading) return <div className='loading'>
            <img src='./loader.gif' alt='loading' /></div>;
        return (<div className='imageTree'>
            <div className='controlBox'>               
                {this.getSubjectDropdown()}
                {this.getHighlightDropdown()}
               </div>
            <h2>{this.subjectArray[this.ms.subjectID]}</h2>
            {this.getTreePage()}

        </div>)
    }
}
export default TreeScreen;